import { render, staticRenderFns } from "./SearchModule.vue?vue&type=template&id=1ea5fb4a&scoped=true&"
import script from "./SearchModule.vue?vue&type=script&lang=js&"
export * from "./SearchModule.vue?vue&type=script&lang=js&"
import style0 from "./SearchModule.vue?vue&type=style&index=0&id=1ea5fb4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea5fb4a",
  null
  
)

export default component.exports